import { Reducer } from "redux";

import { ApiStateWidgetAction, ApiStateWidgetActionTypes, ApiStateWidgetState } from "./types";

const initialSate: ApiStateWidgetState = {
  isLoading: false,
  percentSuccessfulResponses: 0,
  percentErrorsResponses: 0,
  percentZerosResponses: 0,
  percentTimeouts: 0,
};

const reducer: Reducer<ApiStateWidgetState, ApiStateWidgetAction> = (state = initialSate, action) => {
  switch (action.type) {
    case ApiStateWidgetActionTypes.FETCH_REQUEST: {
      return { ...state, isLoading: true };
    }

    case ApiStateWidgetActionTypes.FETCH_ERROR: {
      return { ...state, isLoading: false };
    }

    case ApiStateWidgetActionTypes.FETCH_SUCCESS: {
      return { ...state, ...action.payload, isLoading: false };
    }

    default:
      return state;
  }
};

export default reducer;
